import React, {Component} from 'react';
import {hideModal} from "../../util/utility";
import Iframe from 'react-iframe';

export default class YotiIframe extends Component {

    closeModal = () => {
        document.getElementsByClassName("modal-overlay")[0].style.display = "none";
        const modal = document.getElementById("common-modal-iframe");
        hideModal(modal);
        this.props.navCreateBroadcast();
    }

    render() {
        
        return (
            <div id="common-modal-iframe"
                className="modal fade guest"
                role="dialog"
                aria-labelledby="myModalLabel"
                aria-hidden="true">

                <div className="vertical-alignment-helper">
                    <div className="login-container">
                        <div className="modal-content">
                            <div className="popup-header" style={{top: '1%', right: '1%'}}>
                                <button type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={this.closeModal}
                                >
                                    <img alt={"close-icon"}
                                        src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                                </button>

                            </div>
                            <div className="modal-body">
                                <div className="row" id="yotiContainerIframe">
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}